export default __webpack_public_path__ + "static/media/maniCintillo.0f3b0465.gif";